import firebase from "firebase";
import "firebase/firestore";
import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);
import category from "@/store/category.ts";
import friend from "@/store/friend.ts";
import group from "@/store/group.ts";
import job from "@/store/job.ts";
import record from "@/store/record.ts";
import user from "@/store/user.ts";

export default new Vuex.Store({
  state: {
    //******一般データ系******//
    // 検索文字
    globalSearchWord: "",
    //ログインユーザーまたはその他ユーザーのレコード情報
    records: [],
    // ログイン画面用のstyle
    style: "padding: 0px",
    // ログインユーザー情報
    loginUser: {},
    // ログインユーザーのグループメンバー情報
    myGroupMembers: [],
    // ログインユーザーのグループ情報
    myGroups: [],
    // グループ詳細情報
    group: {},
    // ログインユーザーではないユーザーのグループ情報
    otherUsersGroups: [],
    // グループのチャット情報
    groupChatDatas: [],
    // ジョブIDから取得したグループ情報
    groupByJobId: {},
    //******フラグ系******//
    // ローディング
    loading: false,
    // ログイン状況
    loginStatus: false,
    // 新規登録状況
    isNewUser: false,
    //******モーダル系******//
    //レコードにコメントする用のモーダル
    commentModal: false,
    //ユーザー編集用モーダル
    editUserModal: false,
    //グループフォームモーダル
    groupFormModal: false,
    //グループジョブ登録用モーダル
    groupJobFormModal: false,
    //ジョブ登録用モーダル
    jobFormModal: false,
    //メッセージ表示用モーダル
    successModal: false,
    // グループメンバー表示用モーダル
    groupMemberListModal: false,
    lastFetchdAt: new Date().setMonth(new Date().getMonth() - 1)
    //テスト
  },

  mutations: {
    addLastFetchedAt(state: any, lastFetchdAt: any) {
      state.lastFetchedAt = lastFetchdAt;
    },
    // ローディング画面の表示を切り替えます.
    setLoading(state: any, setLoading: boolean) {
      state.loading = setLoading;
    },
    // ログインユーザー情報を取得します.
    setLoginUser(state: any, { loginUser, userInfo }: {loginUser: any; userInfo: any}) {
      loginUser.userInfo = userInfo;
      state.loginUser = loginUser;
    },
    // 画面のスタイルを切り替えます.
    setStyle(state: any, setStyle: boolean) {
      state.style = setStyle;
    },
    // ログイン状況を取得します.
    fetchLoginStatus(state: any, loginStatus: boolean) {
      state.loginStatus = loginStatus;
    },
    deleteLoginUser(state) {
      state.loginUser = {};
    },
    addGroupChat(
      state: any,
      { groupChatData, contributor }: { groupChatData: any; contributor: any }
    ) {
      const chatData = {
        userName: contributor.userName,
        userPhotoURL: contributor.userPhotoURL,
        postingDate: groupChatData.groupChatPostedAt,
        message: groupChatData.groupChatContent,
      };
      state.groupChatDatas.push(chatData);
    },
    addOtherUsersGroups(
      state: any,
      {
        otherUserGroup,
        groupLeader,
        groupMemberList,
        groupJobList,
      }: {
        otherUserGroup: any;
        groupLeader: any;
        groupMemberList: any;
        groupJobList: any;
      }
    ) {
      otherUserGroup.leaderOfGroup = groupLeader.userName;
      otherUserGroup.groupMemberList = groupMemberList;
      otherUserGroup.groupJobList = groupJobList;
      otherUserGroup.numberOfGroupJobs = groupJobList.length;
      otherUserGroup.numberOfGroupMembers = groupMemberList.length;
      if(otherUserGroup.groupStatus !== 9)state.otherUsersGroups.push(otherUserGroup);
    },
    joinGroup(state: any, group: any){
      state.myGroups.push(group);
    },
    // stateにgroupインスタンス群を挿入するミューテーション
    addGroup(
      state: any,
      {
        myGroup,
        groupLeader,
        groupMemberList,
        groupJobList,
      }: {
        myGroup: any;
        groupLeader: any;
        groupMemberList: any;
        groupJobList: any;
      }
    ) {
      myGroup.leaderOfGroup = groupLeader.userName;
      myGroup.groupMemberList = groupMemberList;
      myGroup.groupJobList = groupJobList;
      myGroup.numberOfGroupMembers = groupMemberList.length;
      myGroup.numberOfGroupJobs = groupJobList.length;
      if(myGroup.groupStatus !== 9)state.myGroups.push(myGroup);
    },
    resetGroup(state: any) {
      state.group = {};
    },
    resetMyGroupMembers(state: any) {
      state.myGroupMembers = [];
    },
    resetGroupChats(state: any) {
      state.groupChatDatas = [];
    },
    resetMyGroups(state: any) {
      state.myGroups = [];
    },
    resetOtherUsersGroups(state: any) {
      state.otherUsersGroups = [];
    },
    updateMyGroup(state: any, group: any) {
      group.leaderOfGroup = group.groupLeaderData.userName;
      group.numberOfGroupJobs = group.groupJobList.length;
      group.numberOfGroupMembers = group.groupMemberList.length;
      group.joined = true
      const index = state.myGroups.findIndex(
        (myGroup: any) => myGroup.groupId === group.groupId
      );
      state.myGroups[index] = group;
      console.log("改変するグループ")
      console.log(group)
      console.log(state.myGroups)
    },
    // stateのmyGroupsから特定のグループ情報を削除する
    deleteMyGroup(state: any, group: any) {
      const index = state.myGroups.findIndex((myGroup: any) => myGroup.groupId === group.groupId);
      state.myGroups.splice(index, 1);
    },
    // stateのmyGroupMembersにuserインスタンス群を挿入するミューテーション
    addMyGroupMembers(state: any, { myGroupMember }: { myGroupMember: any }) {
      state.myGroupMembers.push(myGroupMember);
    },
    //stateにgroupインスタンスを挿入するミューテーション
    addTheGroup(state: any, {
      groupData,
      groupLeaderData,
      groupChatList,
      groupJobList,
      groupMemberList
    }: {
      groupData: any;
      groupLeaderData: any;
      groupChatList: any;
      groupJobList: any;
      groupMemberList: any;
    }) {
      Vue.set(state.group,'groupName', groupData.groupName)
      Vue.set(state.group,'groupRequirements',groupData.groupRequirements)
      Vue.set(state.group,'groupId',groupData.groupId)
      Vue.set(state.group,'groupLeaderData',groupLeaderData)
      Vue.set(state.group,'groupChatList',groupChatList)
      Vue.set(state.group,'groupJobList',groupJobList)
      Vue.set(state.group,'groupMemberList',groupMemberList)
    },
    toggleGroupMemberListModal(state) {
      state.groupMemberListModal = !state.groupMemberListModal;
    },
    toggleGroupFormModal(state) {
      state.groupFormModal = !state.groupFormModal;
    },
    toggleGroupJobFormModal(state) {
      state.groupJobFormModal = !state.groupJobFormModal;
    },
    toggleCommentModal(state) {
      state.commentModal = !state.commentModal;
    },
    fetchRecords(state: any, records: any) {
      state.records.push(records);
    },
    toggleEditUserModal(state) {
      state.editUserModal = !state.editUserModal;
    },
    fetchLoginUser(state: any, loginUser: any) {
      state.loginUser = loginUser;
    },
    resetRecords(state) {
      state.records = [];
    },
    closeCommentModal(state) {
      state.commentModal = false;
    },
    // 検索文字を格納します
    setGlobalSearchWord(state: any, globalSearchWord: string) {
      state.globalSearchWord = globalSearchWord;
    },
    toggleSuccessModal(state) {
      state.successModal = !state.successModal;
    },
    updateUserProfile(state: any, userProfile: string) {
      state.loginUser.userInfo.userProfile = userProfile;
    },
    addGroupByJobId(state: any, group: any){
      Vue.set(state, 'groupByJobId', group)
    }
  },

  actions: {
    // ローディング画面の表示を切り替えます.
    setLoading({ commit }: any, setLoading: boolean) {
      commit("setLoading", setLoading);
    },
    // ログインユーザー情報を取得します.
    setLoginUser({ commit }: any, loginUser: any) {
      const db = firebase.firestore();
      db.collection('users').doc(loginUser.uid).get().then((doc: any) => {
        commit("setLoginUser", {loginUser: loginUser, userInfo: doc.data()});
      })
    },
    // ローディング画面の表示を切り替えます.
    setStyle({ commit }: any, setStyle: string) {
      commit("setStyle", setStyle);
    },
    // ログイン状況を取得します.
    fetchLoginStatus({ commit }: any, loginStatus: boolean) {
      commit("fetchLoginStatus", loginStatus);
    },
    deleteLoginUser({ commit }: { commit: any }) {
      commit("deleteLoginUser");
    },
    // グループ自体を削除する
    deleteGroup({commit,getters}: {commit: any;getters: any}, group: any) {
      const userId = String(getters.loginUserId);
      const groupId = String(group.groupId);
      const groupName = group.groupName;
      const db = firebase.firestore();
      const usersCollection = db.collection(`users`);
      const groupsCollection = db.collection(`groups`);

      usersCollection
        .doc(userId)
        .collection('groups')
        .doc(groupId)
        .delete()
        .then(function() {
          groupsCollection
            .doc(groupId)
            .collection(`members`)
            .doc(userId)
            .delete()
            .then(function() {
              groupsCollection
                .doc(groupId)
                .delete()
                .then(() => {
                  alert(groupName + " から脱退しました。");
                  commit('deleteMyGroup',group);
                })
            })
        })
    },
    // グループを脱退する
    releaseGroups(
      { commit, getters }: { commit: any; getters: any },
      group: any
    ) {
      const userId = String(getters.loginUserId);
      const groupId = String(group.groupId);
      const groupName = group.groupName;
      const db = firebase.firestore();
      const usersCollection = db.collection("users");
      const groupsCollection = db.collection("groups");

      usersCollection
        .doc(userId)
        .collection("groups")
        .doc(groupId)
        .delete()
        .then(function() {
          groupsCollection
            .doc(groupId)
            .collection("members")
            .doc(userId)
            .delete()
            // 他にグループメンバーがいればグループ参加日時が一番古いmemberのuserIdをgroupLeaderUserIdにセットする
            .then(function() {
              groupsCollection
              .doc(groupId)
              .collection("members")
              .orderBy("groupInsertDate")
              .limit(1)
              .get()
              .then(snapshot => snapshot
                .forEach(userDoc => {
                  const newGroupLeaderUserId = userDoc.data().userId;
                  groupsCollection
                    .doc(groupId)
                    .update({
                      groupLeaderUserId: newGroupLeaderUserId
                    })
                  }))
                  alert(groupName + " から脱退しました。");
                  commit('deleteMyGroup',group);
                })
        })
        .catch((error) => {
          console.error("Error removing document: ", error);
        });
    },
    // グループチャット情報の取得
    fetchGroupChats({ getters,commit }: { getters: any; commit: any }, groupId: any) {
      commit("resetGroupChats");
      const db = firebase.firestore();
      const groupCollection = db.collection("groups");
      const lastFetchedAt = firebase.firestore.Timestamp.fromMillis(getters.lastFetchdAt);
      // groupsコレクションの中のグループチャットID一覧を取得する
       groupCollection.doc(groupId).collection("chats").where("groupChatPostedAt", ">", lastFetchedAt).onSnapshot((snapshot) =>
       snapshot.docChanges().forEach(change => {
         if(change.type === "added"){
           db.collection(`groups`)
           .doc(groupId)
           .collection(`chats`)
           .where("groupChatId", "==", change.doc.id)
           .get()
           .then((snapshot) =>
           snapshot.forEach((chatDoc) => {
             // 投稿者のIDを取得
             const userId = chatDoc.data().userId;
             db.collection(`users`)
             .doc(userId)
             .get()
             .then((doc) => {
               // 取得した投稿者のIDから投稿者の情報を取得
               const contributor = doc.data();
               commit("addGroupChat", {
                 groupChatData: chatDoc.data(),
                 contributor: contributor,
                });
                commit("addLastFetchedAt", new Date());
              });
            })
            );
          }
          })
          );
        },
    // ログインユーザーではないユーザーの所属グループ情報の取得
    fetchOtherUserGroups({ commit }: { commit: any }, userId: any) {
      commit("resetOtherUsersGroups");
      const db = firebase.firestore();
      const otherUsersGroupIdSnaps = db
        .collection(`users/${userId}/groups`)
        .get();
      otherUsersGroupIdSnaps.then((snapshot) =>
        snapshot.forEach((doc) => {
          db.collection(`groups`)
            .where("groupId", "==", doc.id)
            .get()
            .then((snapshot) =>
              snapshot.forEach((groupDoc) => {
                const groupLeaderUserId = groupDoc.data().groupLeaderUserId;
                db.collection("users")
                  .doc(groupLeaderUserId)
                  .get()
                  .then((doc) => {
                    const groupLeader = doc.data();

                    const groupJobList: any = [];
                    db.collection(`groups`)
                      .doc(groupDoc.id)
                      .collection(`jobs`)
                      .get()
                      .then((snapshot) => {
                        snapshot.forEach((jobDoc) => {
                          groupJobList.push(jobDoc.data());
                        });
                      });
                    const groupMemberList: any = [];
                    db.collection(`groups`)
                      .doc(groupDoc.id)
                      .collection(`members`)
                      .get()
                      .then((snapshot) => {
                        snapshot.forEach((memberDoc) => {
                          groupMemberList.push(memberDoc.data().userId);
                        });
                        commit(`addOtherUsersGroups`, {
                          otherUserGroup: groupDoc.data(),
                          groupLeader: groupLeader,
                          groupMemberList: groupMemberList,
                          groupJobList: groupJobList,
                        });
                      });
                  });
              })
            );
        })
      );
    },
        // groupIdに紐付いたグループインスタンスを取得する
        fetchTheGroup({ commit }: { commit: any }, groupId: any) {
          commit('resetGroup')
          const db = firebase.firestore();
           db.collection("groups")
            .doc(groupId)
            .get()
            .then(async (groupDoc: any) => {
              // グループIDに基づくグループのフィールド情報を取得
              const groupData = groupDoc.data();

              const groupLeaderUserId = groupDoc.data().groupLeaderUserId;
              // グループリーダーのユーザーIDを元にグループリーダーの情報を取得
              let groupLeaderData = null
              
              await db.collection(`users`)
                .doc(groupLeaderUserId)
                .get()
                .then((groupLeaderDoc) => {
                  groupLeaderData = groupLeaderDoc.data()
                });

              // グループIDに基づくchatsサブコレクションのID群を取得
              const groupChatList: any = [];
              await db.collection(`groups`)
                .doc(groupId)
                .collection(`chats`)
                .get()
                .then((snapshot) => {
                  snapshot.forEach((chatDoc) => {
                    groupChatList.push(chatDoc.data());
                  });
                });

              // グループIDに基づくjobsサブコレクションのID群を取得
              const groupJobList: any = [];
              await db.collection(`groups`)
                .doc(groupId)
                .collection(`jobs`)
                .get()
                .then((snapshot) => {
                  snapshot.forEach((jobDoc) => {
                    groupJobList.push(jobDoc.data());
                  });
                });

              // グループIDに基づくmembersサブコレクションのID群を取得
              const groupMemberList: any = [];
              await db.collection(`groups`)
                .doc(groupId)
                .collection(`members`)
                .get()
                .then((snapshot) => {
                  snapshot.forEach((memberDoc) => {
                    groupMemberList.push(memberDoc.data());
                  });
                });
              
              commit("addTheGroup", {
                groupData: groupData,
                groupLeaderData: groupLeaderData,
                groupChatList: groupChatList,
                groupJobList: groupJobList,
                groupMemberList: groupMemberList
              })
            })
            //.then((doc).then => commit("addTheGroup", doc.data()));
        },
    // ログインユーザーの所属するグループ情報を取得する
    fetchMyGroups({ commit }: any, user: any) {
      commit("resetMyGroups");
      const db = firebase.firestore();
      const userId = user.uid
      const myGroupIdsnaps = db.collection(`users/${userId}/groups`).get();
      myGroupIdsnaps.then((snapshot) =>
        snapshot.forEach((doc) => {
          db.collection(`groups`)
            .where("groupId", "==", doc.id)
            .get()
            .then((snapshot) =>
              snapshot.forEach((groupDoc) => {
                const groupLeaderUserId = groupDoc.data().groupLeaderUserId;
                db.collection("users")
                  .doc(groupLeaderUserId)
                  .get()
                  .then((doc) => {
                    const groupLeader = doc.data();

                    const groupJobList: any = [];
                    db.collection(`groups`)
                      .doc(groupDoc.id)
                      .collection(`jobs`)
                      .get()
                      .then((snapshot) => {
                        snapshot.forEach((jobDoc) => {
                          groupJobList.push(jobDoc.data());
                        });
                      });
                    const groupMemberList: any = [];
                    // グループコレクションからメンバーID一覧を取得し回す memberDocにはグループに所属しているユーザーのユーザーIDと所属日時が入っている
                    db.collection(`groups`)
                      .doc(groupDoc.id)
                      .collection(`members`)
                      .get()
                      .then((snapshot) => {
                        snapshot.forEach((memberDoc) => {
                          groupMemberList.push(memberDoc.data().userId);
                        });
                        commit("addGroup", {
                          myGroup: groupDoc.data(),
                          groupLeader: groupLeader,
                          groupMemberList: groupMemberList,
                          groupJobList: groupJobList,
                        });
                      });
                  });
              })
            );
        })
      );
    },
    // 自身の所属するグループを更新する
    updateMyGroup({ commit }: { commit: any }, group: any) {
      const db = firebase.firestore();
      db.collection("groups")
        .doc(group.groupId)
        .update({
          groupRequirements: group.groupRequirements,
          groupName: group.groupName,
        })
        .then(() => {
          commit("updateMyGroup", group);
        });
    },
    // ログインユーザーが所属するグループのメンバー情報を取得する
    fetchMyGroupMembers({ commit }: { commit: any }, groupId: any) {
      commit("resetMyGroupMembers");
      const db = firebase.firestore();
      const myGroupMemberIdSnaps = db
        .collection(`groups/${groupId}/members`)
        .get();
      myGroupMemberIdSnaps.then((snapshot) =>
        snapshot.forEach((doc) => {
          db.collection(`users`)
            .doc(doc.id)
            .get()
            .then((doc) => {
              commit("addMyGroupMembers", { myGroupMember: doc.data() });
            });
        })
      );
    },
    // グループチャットを送る(groups/groupId/chatsに登録)
    sendGroupChat({ getters}, groupChatData) {
      const db = firebase.firestore();
      const groupId = getters.group.groupId;
      const groupCollection = db.collection("groups");
      const groupChatId = groupCollection
        .doc(groupId)
        .collection("chats")
        .doc().id;
      groupChatData.groupChatId = groupChatId;
      // 取得したグループチャットのIDを含む登録する情報をオブジェクトにセットする
      const postData = {
        userId: groupChatData.userId,
        groupChatId: groupChatId,
        groupChatContent: groupChatData.message,
        groupChatPostedAt: groupChatData.postingDate,
      };
      // 上記のオブジェクトをDBに登録する
        groupCollection.doc(groupId)
          .collection("chats")
          .doc(groupChatId).set(postData);
        
    },
    // グループを作成するためのメソッド
    addGroup({ getters, commit }, group) {
      const db = firebase.firestore();
      const userId = getters.loginUserId;
      const groupInsertDate = new Date();
      const member = { userId: userId, groupInsertDate: groupInsertDate };

      const addGroupBatch = db.batch();
      const groupCollection = db.collection("groups");
      const userCollection = db.collection("users");
      // 作成したグループのIDを取得
      const groupId = groupCollection.doc().id;
      group.groupId = groupId;
      const userGroup = { groupId: groupId };
      addGroupBatch.set(groupCollection.doc(groupId), group);
      addGroupBatch.set(
        groupCollection
          .doc(groupId)
          .collection("members")
          .doc(userId),
        member
      );
      addGroupBatch.set(
        userCollection
          .doc(userId)
          .collection("groups")
          .doc(groupId),
        userGroup
      );
      addGroupBatch.commit().then(() =>
        commit("addGroup", {
          myGroup: group,
          groupLeader: { userName: getters.loginUserName },
          groupMemberList: [getters.loginUserId],
          groupJobList: [],
        })
      );
    },

    joinTheGroup(
      { commit, getters }: { commit: any; getters: any },
      group: any
    ) {
      const db = firebase.firestore();
      const userId = getters.loginUserId;
      const groupInsertDate = new Date();
      // ユーザー情報にIDとグループ参加日時を入れる
      const member = { userId: userId, groupInsertDate: groupInsertDate };
      const groupId = group.groupId;
      const userGroup = { groupId: groupId };
      const joinTheGroupBatch = db.batch();
      const groupCollection = db.collection(`groups`);
      const userCollection = db.collection(`users`);
      // groups/groupId/members/userIdに自身のuserIdをセットする
      joinTheGroupBatch.set(
        groupCollection
          .doc(groupId)
          .collection(`members`)
          .doc(userId),
        member
      );
      // users/userId/groups/groupIdに参加するグループIdをセットする
      joinTheGroupBatch.set(
        userCollection
          .doc(userId)
          .collection(`groups`)
          .doc(groupId),
        userGroup
      );
      joinTheGroupBatch
        .commit()
        .then(() =>
          commit("joinGroup",group)
        );
    },
    fetchTheUser({ commit }: { commit: any }, groupLeaderUserId: any) {
      const db = firebase.firestore();
      db.collection("users")
        .doc(groupLeaderUserId)
        .get()
        .then((doc) => commit("addTheUser", doc.data()));
    },
    toggleGroupMemberListModal({ commit }) {
      commit("toggleGroupMemberListModal")
    },
    //グループジョブモーダルを開閉するメソッド
    toggleGroupJobFormModal({ commit }) {
      commit("toggleGroupJobFormModal");
    },
    //グループフォームを開閉するメソッド
    toggleGroupFormModal({ commit }) {
      commit("toggleGroupFormModal");
    },
    //今日のジョブをリセットするためのメソッド
    resetTodaysJobs({ commit }) {
      commit("resetTodaysJobs");
    },
    //コメントモーダルを開閉するためのメソッド
    toggleCommentModal({ commit }) {
      commit("toggleCommentModal");
    },
    //ユーザー情報を編集するモーダルを開閉するためのメソッド
    toggleEditUserModal({ commit }: any) {
      commit("toggleEditUserModal");
    },
    //コメントをモーダルを閉じる用のメソッド
    closeCommentModal({ commit }) {
      commit("closeCommentModal");
    },
    // 検索文字を格納します
    setGlobalSearchWord({ commit }: any, globalSearchWord: string) {
      commit("setGlobalSearchWord", globalSearchWord);
    },
    //recordsをリセットするためのメソッド
    resetRecords({ commit }: any) {
      commit("resetRecords");
    },
    //マイページまたはその他ユーザーのページで表示するレコードを取得するメソッド
    fetchRecords({ getters, commit }: any, userId: any) {
      const db = firebase.firestore();
      const usersCollection = db.collection("users");
      const recordsCollection = db.collection("records");
      const jobsCollection = db.collection("jobs");
      recordsCollection
        .where("userId", "==", userId)
        .get()
        .then((records) => {
          records.forEach((record) => {
            jobsCollection
              .where("jobId", "==", record.data().jobId)
              .get()
              .then((jobs) => {
                jobs.forEach((job) => {
                  const commentList: any = [];
                  const likeList: any = [];
                  recordsCollection
                    .doc(record.data().recordId)
                    .collection("comments")
                    .get()
                    .then((comments) => {
                      comments.forEach((comment) => {
                        usersCollection
                          .doc(comment.data().commentUserId)
                          .get()
                          .then((user: any) => {
                            if (user !== undefined) {
                              const commentUser = {
                                userId: comment.data().commentUserId,
                                userName: user.data().userName,
                                userPhotoURL: user.data().userPhotoURL,
                              };
                              commentList.push({
                                comment: comment.data(),
                                user: commentUser,
                              });
                            }
                          });
                      });
                    });
                  let isLiked = false;
                  recordsCollection
                    .doc(record.data().recordId)
                    .collection("likes")
                    .get()
                    .then((likes) => {
                      likes.forEach((like) => {
                        if (like.data().likeUserId == getters.loginUserId) {
                          isLiked = true;
                        }
                        likeList.push(like.data());
                      });
                      commit("fetchRecords", {
                        record: record.data(),
                        job: job.data(),
                        comments: commentList,
                        likes: likeList,
                        isLiked: isLiked,
                      });
                    });
                });
              });
          });
        });
    },
    // ユーザープロフィールを更新します.
    updateUserProfile({ commit, getters }: any, userProfile: string) {
      commit("updateUserProfile", userProfile);
      firebase.firestore().collection("users").doc(getters.loginUserId).update({ userProfile: userProfile });
    },
    //ログインユーザーまたはその他ユーザーのデータを取得するメソッド（マイページもしくはその他ユーザーページで使用）
    fetchUserData({ getters, commit }: any, userId: any) {
      const db = firebase.firestore();
      const usersCollection = db.collection("users");
      const jobsCollection = db.collection("jobs");
      const recordsCollection = db.collection("records");
      usersCollection
        .doc(userId)
        .get()
        .then((doc) => {
          const jobList: any = [];
          const friendList: any = [];
          const groupList: any = [];
          usersCollection
            .doc(userId)
            .collection("jobs")
            .get()
            .then((userJobs) => {
              userJobs.forEach((userJob) => {
                jobsCollection
                  .where("jobId", "==", userJob.data().jobId)
                  .where("jobStatus", "==", 1)
                  .get()
                  .then((jobs) => {
                    jobs.forEach((job) => {
                      const recordList: any = [];
                      recordsCollection
                        .where("jobId", "==", userJob.data().jobId)
                        .where("userId", "==", userId)
                        .get()
                        .then((records) => {
                          records.forEach((record) => {
                            recordList.push(record.data());
                          });
                        });
                      jobList.push({ job: job.data(), records: recordList });
                    });
                  });
              });
            });
          usersCollection
            .doc(userId)
            .collection("friends")
            .where("friendStatus", "==", 3)
            .get()
            .then((friends) => {
              friends.forEach((friend) => {
                friendList.push(friend.data());
              });
            });
          usersCollection
            .doc(userId)
            .collection("groups")
            .get()
            .then((groups) => {
              groups.forEach((group) => {
                groupList.push(group);
              });
            });
          commit("fetchLoginUser", {
            userDoc: doc.data(),
            jobs: jobList,
            friends: friendList,
            groups: groupList,
          });
        });
    },
    toggleSuccessModal({ commit }) {
      commit("toggleSuccessModal");
    },
    // ジョブIDからグループ情報を取得する
    getGroupByJobId({ commit }: any, jobId: string){
      const db = firebase.firestore();
      db.collection('jobs').doc(jobId).get().then((doc: any) => {
        const groupId = doc.data().groupId
        db.collection('groups').doc(groupId).get().then((doc: any) => {
          commit('addGroupByJobId', doc.data())
        })
      })
    }
  },

  getters: {
    // ローディング
    loading: (state) => (state.loading ? (state as any).loading : ""),
    // ログイン状況
    loginStatus: (state) => state.loginStatus ? (state as any).loginStatus : "",
    // ログインユーザーメールアドレス
    loginUserEmail: (state) => state.loginUser ? (state as any).loginUser.email : "",
    // ログインユーザーID
    loginUserId: (state) => state.loginUser ? (state as any).loginUser.uid : "",
    // ログインユーザーが保有するアプリ固有情報
    loginUserInfo: (state) => state.loginUser ? state.loginUser.userInfo : "",
    // ログインユーザー名
    loginUserName: (state) => state.loginUser ? (state as any).loginUser.displayName : "",
    // ログインユーザー画像
    loginUserPhotoURL: (state) => state.loginUser ? (state as any).loginUser.photoURL : "",
    // ログインユーザーが持つグループ情報
    myGroups: (state: any) => (state.myGroups ? (state as any).myGroups : []),
    // グループメンバー情報
    myGroupMembers: (state: any) => state.myGroupMembers ? state.myGroupMembers : "",
    // グローバル検索文字
    globalSearchWord: (state: any) => state.globalSearchWord ? state.globalSearchWord : "",
    // グループ情報
    group: (state: any) => state.group ? state.group : "",
    groupChatDatas: (state: any) => state.groupChatDatas ? state.groupChatDatas : "",
    // 他のユーザーが持つグループ情報
    otherUsersGroups: (state: any) => state.otherUsersGroups ? state.otherUsersGroups : "",
    // スタイル
    style: (state) => (state.style ? (state as any).style : ""),
    lastFetchdAt: (state: any) => state.lastFetchdAt ? state.lastFetchdAt : [],
    groupByJobId: (state: any) =>  state.groupByJobId ? state.groupByJobId : "",
  },

  modules: {
    category: category,
    friend: friend,
    group: group,
    job: job,
    record: record,
    user: user,
  },
});
